import { useSnapshot } from 'valtio';

import {
  CommonModalName,
  StudioModalName,
} from '@cartwhl/common/stores/navigationStore';
import PurchaseSpinsModal from '@cartwhl/ui/modals/PurchaseSpinsModal';
import SpinsExplainedModal from '@cartwhl/ui/modals/SpinsExplainedModal';

import { BrowseMotionsModal } from 'components/BrowseMotions';
import {
  CharacterRetargetingModal,
  CharacterRiggingModal,
  UploadVerificationModal,
} from 'components/CharacterRigging';
import DownloadModal from 'components/DownloadModal';
import { EditMotionModal } from 'components/EditMotionModal';
import { ImageUploadModal } from 'components/ImageUploadModal';
import {
  FlaggedVideoModal,
  VideoUploadModal,
} from 'components/VideoUploadModal';
import AboutModal from 'components/modals/AboutModal';
import CharacterRenameModal from 'components/modals/CharacterRenameModal';
import FeedbackModal from 'components/modals/FeedbackModal';
import NewSessionModal from 'components/modals/NewSessionModal';
import ReadyForMoreSpinsModal from 'components/modals/ReadyForMoreSpinsModal';
import WarnBadMotionPredictedModal from 'components/modals/WarnBadMotionPredictedModal';
import { navigationStore } from 'stores';

export default function PageManager() {
  const { modal } = useSnapshot(navigationStore.state);

  let modalToShow = <></>;

  switch (modal.type) {
    case CommonModalName.PURCHASE_SPINS:
      modalToShow = <PurchaseSpinsModal close={navigationStore.closeModal} />;
      break;
    case CommonModalName.EXPLAIN_SPINS:
      modalToShow = <SpinsExplainedModal close={navigationStore.closeModal} />;
      break;
    case StudioModalName.DOWNLOAD:
      modalToShow = <DownloadModal close={navigationStore.closeModal} />;
      break;
    case StudioModalName.FEEDBACK:
      modalToShow = (
        <FeedbackModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.WELCOME:
      modalToShow = <AboutModal close={navigationStore.closeModal} />;
      break;
    case StudioModalName.NEW_SESSION:
      modalToShow = <NewSessionModal close={navigationStore.closeModal} />;
      break;
    case StudioModalName.RENAME_CHARACTER:
      modalToShow = (
        <CharacterRenameModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.IMAGE_UPLOAD:
      modalToShow = (
        <ImageUploadModal
          close={navigationStore.closeModal}
          initialStatus={modal.payload?.mode ?? 'file picker'}
          initialSourceImageBlob={modal.payload?.initialSourceImageBlob}
        />
      );
      break;
    case StudioModalName.VIDEO_UPLOAD:
      modalToShow = (
        <VideoUploadModal
          close={navigationStore.closeModal}
          initialStatus={modal.payload?.mode ?? 'file picker'}
          initialSourceVideoBlob={modal.payload?.initialSourceVideoBlob}
        />
      );
      break;
    case StudioModalName.BROWSE:
      modalToShow = (
        <BrowseMotionsModal
          close={navigationStore.closeModal}
          prefillSearchTerm={modal.payload?.prefillSearchTerm}
          browseItemJobId={modal.payload?.browseItemJobId}
        />
      );
      break;
    case StudioModalName.READY_FOR_MORE_SPINS:
      modalToShow = (
        <ReadyForMoreSpinsModal close={navigationStore.closeModal} />
      );
      break;
    case StudioModalName.AUTO_RIGGING:
      modalToShow = (
        <CharacterRiggingModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.RETARGETING:
      modalToShow = (
        <CharacterRetargetingModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.UPLOAD_VERIFICATION:
      modalToShow = (
        <UploadVerificationModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.FLAGGED_VIDEO:
      modalToShow = <FlaggedVideoModal close={navigationStore.closeModal} />;
      break;
    case StudioModalName.WARN_BAD_MOTION_PREDICTED:
      modalToShow = (
        <WarnBadMotionPredictedModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
    case StudioModalName.EDIT_MOTION:
      modalToShow = (
        <EditMotionModal
          close={navigationStore.closeModal}
          payload={modal.payload}
        />
      );
      break;
  }

  return modalToShow;
}
